import { Redirect, Route, Switch } from 'react-router-dom'

import OtaBusterAnalytics from './Analytics'
import OtaBusterGuestJourney from './GuestJourney'

function OtaBusterRoutes() {
  return (
    <Switch>
      <Route path="/ota-buster/guest-journey" component={OtaBusterGuestJourney} exact />
      <Route path="/ota-buster/analytics" component={OtaBusterAnalytics} exact />
      <Redirect from="/ota-buster" to="/ota-buster/guest-journey" exact />
    </Switch>
  )
}

export default OtaBusterRoutes
